import { useEffect, useMemo } from 'react';
import {
  FeatureFlagName,
  getFeatureFlag,
  reportFeatureFlag
} from 'core/services/featureFlags';

/** Resolves a flag's value and reports the evaluation to RUM once per mount. */
export function useFeatureFlag(name: FeatureFlagName): boolean {
  const value = useMemo(() => getFeatureFlag(name), [name]);

  // External synchronisation with Datadog (a non-React store), not a derived render value —
  // must run once per mount, not on every render.
  useEffect(() => {
    reportFeatureFlag(name, value);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return value;
}
